export default __webpack_public_path__ + "static/card_img-4-3749ddc9bd09925e3855a5f1087f28d1.jpg";